import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import {Category, PriceLevel, TicketFee} from "../models"
import * as ui  from "../models/ui"
import { Response } from '@angular/http';
import {MessageActions} from "./message.actions"
import { UnsafeAction } from "./UnsafeAction"
@Injectable()
export class CategoryFormActions {

	static DISPLAY_CATEGORY_CHANGE ="[CategoryForm] DisplayCategoryChange"
	public displayCategoryChange(displayCategory:ui.DisplayCategory): UnsafeAction {
		return {
			type: CategoryFormActions.DISPLAY_CATEGORY_CHANGE,
			payload:displayCategory
		}
	}

	static NEW_DISPLAY_CATEGORIES ="[CategoryForm] new DisplayCategories"

	public newDisplayCategories(displayCategories: ui.DisplayCategory[]): UnsafeAction{
		return {
			type: CategoryFormActions.NEW_DISPLAY_CATEGORIES,
			payload:displayCategories
		}
	}

	static ADD_DISPLAY_CATEGORY = "[CategoryForm] Add DisplayCategory"
	public addDisplayCategory(dc:ui.DisplayCategory): UnsafeAction{
		return {
			type: CategoryFormActions.ADD_DISPLAY_CATEGORY,
			payload:dc
		}
	}

	static ADD_REDUCED_PRICELEVEL = "[CategoryForm] Add reduced PriceLevel"
	public addReducedPriceLevel(categoryUUID: string): UnsafeAction{
		return {
			type: CategoryFormActions.ADD_REDUCED_PRICELEVEL,
			payload: categoryUUID
		}
	}
	static SAVE_DISPLAY_CATEGORY = "[CategoryForm] save";
	public saveDisplayCategories(categoryCollectionUrl: string): UnsafeAction{
		return {
			type: CategoryFormActions.SAVE_DISPLAY_CATEGORY,
			payload: categoryCollectionUrl
		}
	}

	static CATEGORY_AND_PRICELEVEL_SAVED = "[CategoryForm] Save Successfull"
	public categoryAndPriceLevelSaved(categories: Category[], cbls: ui.CombinedPriceLevel[]): UnsafeAction{
		return {
			type: CategoryFormActions.CATEGORY_AND_PRICELEVEL_SAVED,
			payload: {
				categories: categories,
				combinedPriceLevels: cbls
			}
		}
	}

	static SAVE_DISPLAY_CATEGORY__STATE_COMPLETED = "[CategoryForm] State Completed (vat and fees set)"

	static TOGGLE_GLOBAL_FEES ="[CategoryForm] Toggle global Fees"
	toggleGlobalFees(): Action{
		return {
			type: CategoryFormActions.TOGGLE_GLOBAL_FEES
		}
	}

	static NEW_GLOBAL_FEES = "[CategoryForm] new global Fees"
	newGlobalFees(fc: ui.FeeCollection): UnsafeAction{
		return {
			type: CategoryFormActions.NEW_GLOBAL_FEES,
			payload: fc
		}
	}

	static CANCEL_GLOBAL_FEE_WARNING = "[CategoryForm] cancel global fee warning"
	cancelGloablFeeWarning(): Action{
		return {
			type: CategoryFormActions.CANCEL_GLOBAL_FEE_WARNING
		}
	}

	static FORCE_EMPTY_GLOBAL_FEE = "[CategoryForm] force empty global fees"
	forceEmptyGlobalFees(): Action{
		return {
			type: CategoryFormActions.FORCE_EMPTY_GLOBAL_FEE
		}
	}

	static DELETE_CATEGORY = "[CategoryForm] delete Category"
	deleteCategory(dc:ui.DisplayCategory): UnsafeAction{
		return {
			type: CategoryFormActions.DELETE_CATEGORY,
			payload:dc
		}
	}

	static CANCEL_CATEGORY_DELETE = "[CategoryForm] cancel Category delete"
	cancelCategoryDelete(): Action{
		return {
			type: CategoryFormActions.CANCEL_CATEGORY_DELETE
		}
	}

	static FORCE_CATEGORY_DELETE = "[CategoryForm] force Category delete"
	forceCategoryDelete(): Action{
		return {
			type: CategoryFormActions.FORCE_CATEGORY_DELETE
		}
	}

	static FORCE_CATEGORY_DELETE_SUCCESS ="[CategoryForm] Category successful deleted"
	forceCategoryDeleteSuccess(): Action{
		return {
			type: CategoryFormActions.FORCE_CATEGORY_DELETE_SUCCESS
		}
	}

	static DELETE_REDUCED_PRICELEVEL = "[CategoryForm] Delete Pricelevel"
	deleteReducedPriceLevel(priceLevel: PriceLevel,displayCategory:ui.DisplayCategory): UnsafeAction{
		return {
			type: CategoryFormActions.DELETE_REDUCED_PRICELEVEL,
			payload: {
				priceLevel: priceLevel,
				displayCategory: displayCategory
			}
		}
	}

	static CANCEL_DELETE_REDUCED_PRICELEVEL =" [CategoryForm] Cancel Delete PriceLevel"
	cancelPriceLevelDelete():Action {
		return {
			type:CategoryFormActions.CANCEL_DELETE_REDUCED_PRICELEVEL
		}
	}

	static FORCE_DELETE_REDUCED_PRICELEVEL =" [CategoryForm] force Delete PriceLevel"
	forcePriceLevelDelete():Action {
		return {
			type:CategoryFormActions.FORCE_DELETE_REDUCED_PRICELEVEL
		}
	}

	static FORCE_DELETE_REDUCED_PRICELEVEL_SUCCESS =" [CategoryForm] force Delete PriceLevel successful"
	forcePriceLevelDeleteSuccessful(deletedPriceLevel: PriceLevel): UnsafeAction {
		return {
			type: CategoryFormActions.FORCE_DELETE_REDUCED_PRICELEVEL_SUCCESS,
			payload: deletedPriceLevel
		}
	}

	static CATEGORY_FORM_ERROR = "[CategoryForm] error"
	error(error: Response): UnsafeAction {
		return {
			type: CategoryFormActions.CATEGORY_FORM_ERROR,
			payload: error
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/actions/category-form.actions.ts